import styled from 'styled-components';


export const DocumentImportWrapper = styled.div`
  & > div:first-child {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }
`;

